import { Route, Routes } from 'react-router-dom'
import CreateUpload from '../../../forms/Uploads/CreateUpload'
import UploadsList from './UploadsList'
import EditUpload from '../../../forms/Uploads/EditUpload'

const Uploads = (): JSX.Element => {
  return (
    <Routes>
      <Route path="*" element={<UploadsList />}>
        <Route path="create" element={<CreateUpload />} />
        <Route path="edit/:upload_id" element={<EditUpload />} />
      </Route>
    </Routes>
  )
}

export default Uploads
